export default function () {
    const year = new Date(new Date().getTime() + 365 * 24 * 60 * 60 * 1000);
    const cookie = useCookie('correlation', {expires: year, secure: true, path: '/'});

    function get() {
        return cookie.value;
    }

    function set(id) {
        cookie.value = id;
    }

    function remove() {
        cookie.value = null;
    }

    return {get, set, remove};
}
